import {Injectable} from '@angular/core';
import {IoService} from './io.service';
import {Joint} from '../models';

@Injectable()
export class JointService extends IoService {
  protected model = Joint;
  protected listUrl = '/joints/';
}
